// TODO: Can we import this from @spine/events?
export enum EntityEventAction {
  InsertActionRequest = 'insert.ActionRequest',
  UpdateActionRequest = 'update.ActionRequest',
  RemoveActionRequest = 'remove.ActionRequest',
  SoftRemoveActionRequest = 'softremove.ActionRequest',
  InsertProjectMembership = 'insert.ProjectMembership',
  UpdateProjectMembership = 'update.ProjectMembership',
  InsertSensor = 'insert.Sensor',
  InsertUser = 'insert.User'
}

export enum ActionRequestEventAction {
  InsertActionRequest = 'insert.ActionRequest',
  UpdateActionRequest = 'update.ActionRequest',
  RemoveActionRequest = 'remove.ActionRequest',
  SoftRemoveActionRequest = 'softremove.ActionRequest'
}

export enum ProjectMembershipEventAction {
  InsertProjectMembership = 'insert.ProjectMembership',
  UpdateProjectMembership = 'update.ProjectMembership'
}

export enum SensorEventAction {
  InsertSensor = 'insert.Sensor'
}

export enum UserEventAction {
  InsertUser = 'insert.User'
}
